import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';

const STORAGE_PREFIX = 'whatsNew:';

export interface WhatsNewSeenEntry {
  dismissed?: boolean;
  showAgain?: boolean;
  showCount?: number;
  lastSeenAt?: string;
}

export interface WhatsNewState {
  seen: Record<string, WhatsNewSeenEntry>;
}

interface SimpleStorage {
  getItem: (key: string) => string | null | Promise<string | null>;
  setItem: (key: string, value: string) => void | Promise<void>;
}

function getStorage(): SimpleStorage {
  if (Platform.OS !== 'web') return AsyncStorage;
  return {
    getItem: (key: string) => localStorage.getItem(key),
    setItem: (key: string, value: string) => localStorage.setItem(key, value),
  };
}

export async function readWhatsNewState(userId: string): Promise<WhatsNewState> {
  const key = STORAGE_PREFIX + userId;
  const storage = getStorage();
  try {
    const raw = await storage.getItem(key);
    if (!raw) return { seen: {} };
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : { seen: {} };
  } catch (e) {
    return { seen: {} };
  }
}

export async function writeWhatsNewState(userId: string, state: WhatsNewState): Promise<void> {
  const key = STORAGE_PREFIX + userId;
  const storage = getStorage();
  try {
    await storage.setItem(key, JSON.stringify(state));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Failed to write WhatsNew state', e);
  }
}

export async function updateSeenEntry(
  userId: string,
  messageId: string,
  updater: (prev: WhatsNewSeenEntry) => WhatsNewSeenEntry,
): Promise<WhatsNewSeenEntry> {
  const current = await readWhatsNewState(userId);
  const prev = current.seen[messageId] || {};
  const next = updater(prev);
  await writeWhatsNewState(userId, { seen: { ...current.seen, [messageId]: next } });
  return next;
}
